module.exports = "/assets/6ad2f965bfb9d9f790c4c7d5972d4a7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/ZC.png
// module id = 2059
// module chunks = 0